export default {
  data() {
    return {
      props: {
        'tag': '',
        'width': '300px',
        'height': '300px',
        'zIndex': 'auto','maxWidth': '500px',
        'rotation': '0deg',
        'border': '0 none #000000',
        'boxShadow': '0 0 0 0 black initial',
        'borderRadius': '0 0 0 0',
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',

        //Elements for StickyVideo
        'StickyVideo' : false,
        'positionSticky' : '',
        'btnClick' : '',
        'sizeSticky' : '',
        'sizeBtn' : null,
        'ative' : false,

        'src': '',
        'checkBoxAutoPlay': 'false',
        'checkBoxLoop': 'false',
        'checkBoxControl':'false',
        'startYoutube':'0',
        'endYoutube':'0',

        'animation': {
          'in': {
            'action': 'time',   //time/scroll/click/hover
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'speed': 'slow',
            'infinite': false,
          },
          'out': {
            'action': 'time',   //time/scroll/click
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'delay': '1',
            'speed': '1',
            'infinite': false,
          },
        },
      },
      elements: [],
      internal_config: {
        'width': '300px',
        'height': '300px',
        'zIndex': 'auto',
        'rotation': '0deg',
        'border': '0 none #000000',
        'boxShadow': '0 0 0 0 black initial',
        'borderRadius': '0 0 0 0',
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',

        'StickyVideo' : false,
        'positionSticky' : '',

        'src': '',
        'checkBoxAutoPlay': 'false',
        'checkBoxLoop': 'false',
        'checkBoxControl':'false',
        'checkBoxRef':'false',
        'startYoutube':'0',
        'endYoutube':'0',

        'animation': {
          'in': {
            'action': 'time',   //time/scroll/click/hover
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'speed': 'slow',
            'infinite': false,
          },
          'out': {
            'action': 'time',   //time/scroll/click
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'delay': '1',
            'speed': '1',
            'infinite': false,
          },
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/apps/YoutubeVideo/Model.js